import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class InventarioService {

  constructor(private config: ConfigService,
    private http: HttpClient) { }

  getTipoMovimiento(token: String) {
    const requestOptions: object = {
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Inventario/GetTipoMovimiento";
    return this.http.get(url, requestOptions);
  }

  getMovimientos(token: string, idTienda: number, fecha: string, idTipoMovimiento: number) {
    const url = this.config.urlService + "api/Inventario/GetMovimiento/" + idTienda + "/" + fecha + "/" + idTipoMovimiento;
    const requestOptions: object = {
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    return this.http.get(url, requestOptions);
  }

  getRastreoMovimiento(token: string, idTienda: number) {
    const url = this.config.urlService + "api/Inventario/Rastreo/" + idTienda;
    const requestOptions: object = {
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    return this.http.get(url, requestOptions);
  }

  getRastreoProducto(token: string, idProducto: number, idTienda: number, idMovimientoTienda: number) {
    const url = this.config.urlService + "api/Inventario/Rastreo/" + idProducto + "/" + idTienda + "/" + idMovimientoTienda;
    const requestOptions: object = {
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    return this.http.get(url, requestOptions);
  }

  setRegistroMovimiento = (token: String, data: object, idTiendaOrigen: number, hasChange: boolean, idTiendaDestino?: number) => {
    const requestOptions: object = {
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      responseType: 'text'
    }
    const url = this.config.urlService + "api/Inventario/SetMovimiento/" + idTiendaOrigen + "/" + hasChange + "/" + idTiendaDestino
    return this.http.post(url, data, requestOptions);
  }
}
